import { SimpleProps } from '.'
import { NotificationIcon } from './Icon'
import { NotificationLabel } from './Label'
import { cn } from '@lib/cn'
import { FC } from 'react'

export const Simple: FC<SimpleProps> = ({ label }) => {
  return (
    <div className={cn('flex items-center gap-3', 'sm:gap-4')}>
      <NotificationIcon icon="check" />
      <div className="overflow-hidden">
        <NotificationLabel className="font-bold">{label}</NotificationLabel>
      </div>
    </div>
  )
}
